import { Search } from 'lucide-react'
import type { ComponentProps } from 'react'
import { cn } from '@/lib/cn'

/** A pill search box for filtering a page's list as you type. */
export function SearchField({
  label,
  className,
  ...props
}: Omit<ComponentProps<'input'>, 'type'> & {
  /** What it searches, for screen readers ("Search clients"). */
  label: string
}) {
  return (
    <label className={cn('relative inline-flex max-w-xs min-w-[180px] flex-1', className)}>
      <span className="sr-only">{label}</span>
      <Search
        className="pointer-events-none absolute top-1/2 left-3 size-4 -translate-y-1/2 text-ink-subtle"
        aria-hidden="true"
      />
      <input
        type="search"
        className="h-9 w-full rounded-full border border-border-strong bg-surface-raised pr-3.5 pl-9 text-[13px] text-ink placeholder:text-ink-subtle focus-visible:border-ink focus-visible:outline-none"
        {...props}
      />
    </label>
  )
}
